module.exports = __webpack_public_path__ + "static/img/special1.1b6d0d00.png";